import { httpRequest } from "@services/http";
import { PricesheetItem } from "@models/pricesheetitem.model";
import { PricesheetItemSerializer } from "@models/serializers/pricesheetitemSerializer";

export class CommandDeletePricesheetItem {
  async run(contractId: number, pricesheetId: number, itemId: number): Promise<PricesheetItem> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${contractId}/pricesheets/${pricesheetId}/items/${itemId}/`;
    const response = await httpRequest<any>(url, { method: "DELETE" });
    return PricesheetItemSerializer.fromJson(response);
  }
}
